<template>
    <div id="app">
     <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'systemManagement' }, { path: 'menuConfig' }]" />
    <div class="menu-config">
      <el-menu
        active-text-color="#fff"
        unique-opened
        >
        <el-menu-item :index="item.path" v-for="item in noChildren"
        :key="item.id">
        <template>
        <i :class="item.icon" style="margin-right: 20px;"></i>
        <el-input
          v-model="item.authName"
          size="mini"
          class="menu-input"
          placeholder="请输入一级菜单名称"
        />
        <!-- <i class="iconfont icon-dian" style="margin-left: 0px" v-show="icons"></i> -->
        </template>
      </el-menu-item>
        <el-submenu :index="'/' + item.path" v-for=" item in hasChilren "
         :key="item.id">
            <template slot="title">
              <i :class="item.icon" style="margin-right: 20px;"></i>
              <el-input
                v-model="item.authName"
                size="mini"
                class="menu-input"
                placeholder="请输入一级菜单名称"
              />
              <!-- <i class="iconfont icon-dian" style="margin-left: 40px" v-show="icons"></i> -->
            </template>
          <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.childern"
            :key="subItem.id">
              <template>
                <!-- 图表 -->
                <i class=""></i>
                <!-- 文本 -->
                <el-input
                  v-model="subItem.authName"
                  size="mini"
                  class="menu-input"
                  placeholder="请输入二级菜单名称"
                />
                <!-- <i class="iconfont icon-dian" style="margin-left: 40px" v-show="icons"></i> -->
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <div class="menu-config__actions">
          <el-button type="primary" size="small" @click="handleSave">
            保存菜单配置
          </el-button>
        </div>
    </div>
    </div>
</template>
<script>
import { DEFAULT_MENU_LIST, mergeMenuConfig } from '@/utils/menuConfig'

export default {
  data () {
    return {
      token: null,
      menulist: JSON.parse(JSON.stringify(DEFAULT_MENU_LIST))
    }
  },
  created () {
    // 从 store 中获取当前登录用户的 token
    this.token = this.$store.state.print.goodsForeNo.token
    this.fetchMenuConfig()
  },
  computed: {
    noChildren () {
      return this.menulist.filter((item) => !item.childern)
    },
    hasChilren () {
      return this.menulist.filter((item) => item.childern)
    }
  },
  methods: {
    // 获取当前项目的菜单配置；如果未配置返回 null，则使用默认菜单
    // 旧配置缺失的菜单项（如用量统计）会自动补全
    fetchMenuConfig () {
      const params = {
        token: this.token
      }
      this.$api.lonig.getMenuConfig(params).then(res => {
        if (res && res.data && res.data.status === 'success' && res.data.data) {
          const config = mergeMenuConfig(res.data.data)
          if (config && config.length) {
            this.menulist = config
            // 同步更新到 Vuex，侧边栏会自动刷新
            this.$store.commit('print/STORE_MENU_CONFIG', config)
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error('获取菜单配置失败', err)
      })
    },
    // 保存菜单配置
    handleSave () {
      const payload = {
        token: this.token,
        // 接口要求字段为 menu_config
        menu_config: this.menulist
      }
      this.$api.accountMent.updatemenuConfig(payload).then(res => {
        if (res && res.data && res.data.status === 'success') {
          this.$message.success('菜单配置保存成功')
          // 立即同步到 Vuex，侧边栏与面包屑同步最新名称
          this.$store.commit('print/STORE_MENU_CONFIG', mergeMenuConfig(this.menulist))
          // 保存成功后重新获取一次配置并刷新侧边栏
          this.fetchMenuConfig()
        } else {
          this.$message.error((res && res.data && res.data.message) || '菜单配置保存失败')
        }
      }).catch(err => {
        this.$message.error('菜单配置保存失败')
        // eslint-disable-next-line no-console
        console.error('保存菜单配置失败', err)
      })
    }
  }
}

</script>
<style lang="less" scoped>
// 面包屑
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 75px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
.menu-config{
  margin-left: 20%;
  margin-top: 5%;
  width: 400px;
  height: 100%;
  .menu-input{
    width: 200px;
  }
  .menu-config__actions{
    margin-top: 16px;
    text-align: right;
    .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          color: #FFF;
        }
  }
}
// 移动
@media (max-width: 768px) {
      #app{
        overflow-x: hidden;
      }
      .Gnv{
        display: none;
      }
      .menu-config{
        width: calc(100% - 20px);
        max-width: 100%;
        margin: 10px;
        height: auto;
        box-sizing: border-box;
        ::v-deep .el-menu{
          width: 100%;
          border-right: 0;
        }
        .menu-input{
          width: calc(100% - 56px);
          max-width: 100%;
        }
        .menu-config__actions{
          margin-top: 12px;
          text-align: center;
          .el-button{
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }
</style>
